import { Color } from '../uimodels/color';

export class ProgressMarker {
    color: Color = new Color(255, 255, 255);
}



// WEBPACK FOOTER //
// ./src/app/progress/marker.ts